import { render } from "./Flipper.vue?vue&type=template&id=47a3d538"
import script from "./Flipper.vue?vue&type=script&lang=js"
export * from "./Flipper.vue?vue&type=script&lang=js"

import "./Flipper.vue?vue&type=style&index=0&id=47a3d538&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__